module.exports = __webpack_public_path__ + "static/img/14000504.06688fdd.png";